export default "__VITE_ASSET__DHKuBu9G__"